import { BaseInitialState, REDUX_REQUEST_TYPES } from 'app/types/store.types'

export default function baseRequestReducer<T>(
  initialState: BaseInitialState<T>,
  actions: Record<REDUX_REQUEST_TYPES, string>
) {
  return (
    // eslint-disable-next-line default-param-last
    state = initialState,
    action: {
      type: string
      payload: { data: typeof initialState.data; error: any }
    }
  ) => {
    switch (action.type) {
      case actions.REQUEST:
        return {
          ...state,
          loading: true,
          error: false,
        }

      case actions.SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          data: action.payload.data,
        }

      case actions.FAILURE:
        return {
          ...state,
          loading: false,
          data: initialState.data,
          error: action.payload.error,
        }
      default:
        return state
    }
  }
}
